/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_Mode_QuantityInputs */

const vi_packaging_material_tracking_mode_quantity = /** @type {(inputs: Packaging_Material_Tracking_Mode_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo số lượng`)
};

/**

* @param {Packaging_Material_Tracking_Mode_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_mode_quantity = /** @type {((inputs?: Packaging_Material_Tracking_Mode_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_Mode_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_mode_quantity(inputs)
});